/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Stats_Last_SyncInputs */



/**
* | output |
* | --- |
* | "Last Sync" |
*
* @param {Scim_Stats_Last_SyncInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_stats_last_sync = /** @type {((inputs?: Scim_Stats_Last_SyncInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Stats_Last_SyncInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte Synchronisierung")
	return /** @type {LocalizedString} */ ("Last Sync")
});